import styled from 'styled-components';
import {flexStyle} from '../styles';

export const FlexRow = styled.div`
  ${flexStyle}
  flex-direction: row;
`;
